import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Snackbar from '@mui/material/Snackbar';
import {
  getButtonBackgroundColor,
  getHeaderAndNavigationTypography
} from 'styles/helpers/getThemeStyles';

const StyledSnackbar = styled(Snackbar)(({ theme }) => {
  const fontStyles = getHeaderAndNavigationTypography(theme);
  return {
    '& .MuiSnackbarContent-root': {
      backgroundColor: getButtonBackgroundColor(theme),
      justifyContent: 'center',
      ...fontStyles
    }
  };
});

function ExternalPromotionToast({ toastMessage }) {
  const [open, setOpen] = React.useState(true);

  return (
    <StyledSnackbar
      dataTestId="external-promotion-toast"
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={2000}
      message={toastMessage}
      onClose={() => setOpen(false)}
    />
  );
}

ExternalPromotionToast.propTypes = {
  toastMessage: PropTypes.string
};

export default ExternalPromotionToast;
